<template>
  <div class="phone-tool-intelligence">
    <loading v-if="!$store.state.productLoading"></loading>
    <not-available
      v-else-if="availableVersions.length === 0"
      title="手机号攻击情报"
    ></not-available>
    <div v-else class="product-content">
      <div class="product-header">
        <h3 v-if="availableVersions.length === 1">{{ selectedName }}</h3>
        <div v-else class="version-select">
          <span @click="toggleVersionList">
            {{ selectedName }}
            <i
              class="iconfont iconsanjiaoxingbeifen"
              :class="{ active: showVersionList }"
            ></i>
          </span>
          <ul v-if="showVersionList" class="version-list">
            <li
              v-for="version in availableVersions"
              :key="version.value"
              :class="{ active: selectedType === version.value }"
              @click="selectVersion(version.value)"
            >
              {{ version.label }}
            </li>
          </ul>
        </div>
      </div>

      <div
        class="authorization-information"
        :class="{ online: isOnline }"
      >
        <div
          class="information-header"
          :style="informationGridStyle"
        >
          <span v-for="label in informationLabels" :key="label">{{ label }}</span>
        </div>
        <div
          v-if="selectedProduct"
          class="information-row"
          :style="informationGridStyle"
        >
          <template v-if="isOnline">
            <span>{{ quotaTotal }}</span>
            <span>{{ quotaRemaining }}</span>
          </template>
          <span>{{ selectedProduct.ctime || '-' }}</span>
          <span>{{ selectedProduct.expire || '-' }}</span>
          <span>使用中</span>
        </div>
      </div>

      <update-package
        v-if="!isOnline"
        :fetch-data="getGroupReceiveCodeOfflineLog"
        version=""
        default-upgrade-type="minutes"
        :upgrade-options="offlineUpgradeOptions"
      ></update-package>
    </div>
  </div>
</template>

<script>
import NotAvailable from '../../components/mark/notAvailable'
import UpdatePackage from '../riskPhone/components/updatePackage/index.vue'
import { getGroupReceiveCodeOfflineLog } from '@/services/interface'

export default {
  name: 'RiskPhoneAttackMonitor',
  components: { NotAvailable, UpdatePackage },
  data () {
    return {
      selectedType: null,
      showVersionList: false,
      getGroupReceiveCodeOfflineLog,
      versions: [
        {
          label: '手机号攻击情报-在线请求',
          value: 'group_receive_code_online'
        },
        {
          label: '手机号攻击情报-离线版本',
          value: 'group_receive_code'
        }
      ],
      offlineUpgradeOptions: [
        { label: '分钟级更新包', value: 'minutes' }
      ]
    }
  },
  computed: {
    activeProducts () {
      return this.$store.state.product.filter(product => {
        return product.auditflag === '5'
      })
    },
    availableVersions () {
      return this.versions.filter(version => {
        return this.activeProducts.some(product => {
          return product.busi === version.value
        })
      })
    },
    selectedVersion () {
      return this.availableVersions.find(version => {
        return version.value === this.selectedType
      })
    },
    selectedProduct () {
      return this.activeProducts.find(product => {
        return product.busi === this.selectedType
      })
    },
    selectedName () {
      return this.selectedVersion ? this.selectedVersion.label : ''
    },
    isOnline () {
      return this.selectedType === 'group_receive_code_online'
    },
    informationLabels () {
      return this.isOnline
        ? ['授权配额', '剩余配额', '开通时间', '截止时间', '状态']
        : ['开通时间', '截止时间', '状态']
    },
    informationGridStyle () {
      return {
        gridTemplateColumns: `repeat(${this.informationLabels.length}, minmax(0, 1fr))`
      }
    },
    quotaTotal () {
      return this.toQuotaNumber(this.selectedProduct && this.selectedProduct.reqtotal)
    },
    quotaRemaining () {
      const used = this.toQuotaNumber(this.selectedProduct && this.selectedProduct.reqused)
      return Math.max(this.quotaTotal - used, 0)
    }
  },
  watch: {
    availableVersions: {
      immediate: true,
      handler () {
        this.syncSelectedType(this.$route.params.busi)
      }
    },
    '$route.params.busi' (busi) {
      this.syncSelectedType(busi)
    }
  },
  methods: {
    toQuotaNumber (value) {
      const number = Number(value)
      return Number.isFinite(number) ? number : 0
    },
    syncSelectedType (busi) {
      const routeVersion = this.availableVersions.find(version => {
        return version.value === busi
      })
      if (routeVersion) {
        this.selectedType = routeVersion.value
      } else if (!this.selectedVersion) {
        this.selectedType = this.availableVersions.length
          ? this.availableVersions[0].value
          : null
      }
    },
    toggleVersionList () {
      this.showVersionList = !this.showVersionList
    },
    selectVersion (busi) {
      this.selectedType = busi
      this.showVersionList = false
    }
  }
}
</script>

<style lang="scss" scoped>
.phone-tool-intelligence {
  min-height: 100%;
  padding: 30px 40px 48px;
  box-sizing: border-box;
}

.product-header {
  min-height: 30px;
  margin-bottom: 24px;

  h3,
  .version-select {
    color: #1d243c;
    font-size: 18px;
    font-weight: 500;
    line-height: 30px;
  }
}

.version-select {
  position: relative;
  display: inline-block;

  > span {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    cursor: pointer;
  }

  i {
    display: inline-block;
    margin-left: 8px;
    transform: rotate(90deg);

    &.active {
      transform: rotate(270deg);
    }
  }
}

.version-list {
  position: absolute;
  top: 38px;
  left: 0;
  z-index: 99;
  width: max-content;
  min-width: 100%;
  padding: 12px 0;
  background: #fff;
  box-shadow: 0 4px 8px rgba(17, 39, 98, 0.08);

  li {
    height: 40px;
    padding: 0 20px;
    color: #1d243c;
    font-size: 16px;
    font-weight: 400;
    line-height: 40px;
    white-space: nowrap;
    box-sizing: border-box;
    cursor: pointer;

    &:hover,
    &.active {
      background: #dceaff;
    }
  }
}

.authorization-information {
  overflow-x: auto;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(17, 39, 98, 0.04);
}

.information-header,
.information-row {
  display: grid;
  min-width: 480px;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
    padding: 0 8px;
    color: #1d243c;
    text-align: center;
    white-space: nowrap;
    box-sizing: border-box;
  }
}

.authorization-information.online {
  .information-header,
  .information-row {
    min-width: 700px;
  }
}

.information-header {
  border-bottom: 1px solid #eaedf2;

  span {
    height: 58px;
    font-size: 16px;
    font-weight: 500;
  }
}

.information-row span {
  height: 75px;
  font-size: 14px;
  font-weight: 400;
}

@media (max-width: 768px) {
  .phone-tool-intelligence {
    padding: 20px 16px 36px;
  }

  .product-header h3,
  .product-header .version-select {
    font-size: 12px;
    line-height: 22px;
  }

  .version-list li {
    padding: 0 12px;
    font-size: 12px;
  }

  .information-header span,
  .information-row span {
    padding: 0 4px;
    font-size: 12px;
  }
}
</style>
